import React, {Fragment} from "react";
import ReactHookFormError from "./ReactHookFormError";

const FormItemText = ({ heading, name, formSectionName, register, formErrors }) =>
{
    const elementName = formSectionName === undefined ? name : formSectionName + '.' + name ;

    return (
        <Fragment key={name}>
            { heading !== null && <label>{heading}</label> }
            <input className='form-control' {...register(elementName, {
                required: false,
                maxLength: 200
            })} />
            <ReactHookFormError formErrors={formErrors} name={name}/>
        </Fragment>
    )
}

export default FormItemText ;
